export default __webpack_public_path__ + "static/media/mesapc.ff2c13e2.png";